/*
 * @Author: Kuiper
 * @Date: 2021-06-24 20:22:50
 */
import { Store } from 'vuex'
import { StateType } from '../../types'
import { loginApi, testApi, getCaptchaApi, requireAccInfo, testMockApi } from '/@/api/user'
import { LoginParams, LoginResultModel, CoocaaAccountInfo } from '/@/api/user/userModel'

export default {
  async testCall(): Promise<any> {
    try {
      console.log('store testCall in')
      const res = await testApi()
      console.log('store res', res)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async mockCall(): Promise<any> {
    try {
      console.log('store mockCall in')
      const res = await testMockApi()
      console.log('store res', res)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async loginByCaptcha(): Promise<any> {
    try {
      console.log('store loginByCaptcha in')
      const res = await getCaptchaApi()
      console.log('loginByCaptcha', res)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async getUserInfo(context: Store<StateType>, params: any) {
    console.log('派发actions的时候传递数据', params)
    try {
      const queryData = params.accessToken ? params.accessToken : params.access_token
      console.log(queryData)
      const response = await requireAccInfo(queryData)
      if (response) {
        console.log('这是获取到的个人信息', response)
        if (response && response.open_id) {
          let user_name
          if (response.user_name) {
            user_name = response.user_name
          } else {
            user_name = response.nick_name
          }
          const info: CoocaaAccountInfo = {
            code: 1,
            mobile: response.mobile,
            uid: response.open_id,
            ak: params.accessToken,
            avatar: response.avatar,
            nickname: user_name,
            role: params.role,
          }
          context.commit('assign', info)
        }
      }
    } catch (error) {
      return Promise.reject(error)
    }
  },
  async login(
    context: Store<StateType>,
    params: LoginParams
  ): Promise<LoginResultModel | undefined> {
    try {
      console.log('store login in', context, params)
      const { ...loginParams } = params
      const data = await loginApi(loginParams)
      const { token } = data
      console.log('login token:', token)
      return data
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
